import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import KeycloakService from "../config/KeycloakService";
import DashboardLayout from "./dashboard/DashboardLayout";

const MyAccountPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!KeycloakService.isLoggedIn()) {
      navigate("/");
    }
  }, [navigate]);

  if (!KeycloakService.isLoggedIn()) {
    return null;
  }

  return <DashboardLayout />;
};

export default MyAccountPage;
